export enum SessionAgeStatus {
  Actual = 1,
  LastSession = 2,
  OldSession = 3,
}
